import {useState, useRef} from 'react';

function VirtualTourViewer({layouts, title}) {
    const [selectedLayout, setSelectedLayout] = useState('layout01');
    const scrollContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleScroll = (direction) => {
        const container = scrollContainerRef.current;
        const scrollAmount = direction === 'right' ? 400 : -400;
        container.scrollBy({left: scrollAmount, behavior: 'smooth'});
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        const container = scrollContainerRef.current;
        setStartX(e.pageX - container.scrollLeft);
        setScrollLeft(container.scrollLeft);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const container = scrollContainerRef.current;
        const x = e.pageX - container.scrollLeft;
        const walk = (x - startX) * 0.5;
        container.scrollLeft = scrollLeft - walk;
    };

    const handleLayoutClick = (layoutId) => {
        setSelectedLayout(layoutId);
        
    };

    return (
        <div className="flex flex-col items-center w-full p-4">
        <h1 className="text-6xl font-bold text-brand">{title}</h1>
        <div className="flex flex-col items-center mt-8 w-full">
            {/* Container that changes width based on screen size */}
            <div className='container mx-auto max-w-[1160px] w-full flex flex-col gap-6 px-4'>
                {/* add the layout title as an h3 title above the iframe */}
                <h3 className="text-2xl font-bold text-brand-dark">Setup: {layouts.find(layout => layout.id === selectedLayout)?.title}</h3>
                <iframe 
                    // className="w-full h-[400px] md:h-[500px] lg:h-[675px] border-0"
                    className="w-full h-[60vh] border-0"
                    scrolling="no"
                    allowfullscreen 
                    allow="gyroscope; accelerometer; xr-spatial-tracking; vr;"
                    src={layouts.find(layout => layout.id === selectedLayout)?.source} 
                    id="event-iframe"
                    title="Event Layout View"
                >
                </iframe>

                {/* Layout panel - full width on mobile, fixed width on larger screens */}
                <div className="relative w-full">
                    <div 
                    className="w-full overflow-x-scroll scrollbar-hide pb-6 px-2 select-none"
                    ref={scrollContainerRef}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    style={{cursor: isDragging ? 'grabbing' : 'grab'}}
                    >
                        <div className='flex gap-4 min-w-min p-2'>

                            {layouts.map((layout) => (
                            <div 
                                key={layout.id}
                                className={`flex flex-col md:flex-row items-center gap-3 p-4 w-[calc(33.33%-0.75rem)] flex-shrink-0 bg-gray-100 rounded-lg cursor-pointer hover:drop-shadow-md transition-colors select-none
                                ${selectedLayout === layout.id ? 'ring-2 ring-brand' : ''}`} 
                                onClick={() => handleLayoutClick(layout.id)}
                            >
                                <div className="w-full md:w-1/2">
                                    <img  
                                    src={layout.image} 
                                    className="w-full h-[100px] object-cover"
                                    alt = {layout.alt}
                                    />
                                </div>
                                <div className="w-full md:w-1/2 text-center md:text-left">
                                <h3>{layout.title}</h3>
                                <p className="text-sm text-gray-600 italic">{layout.description}</p>
                                </div>
                            </div>
                            ))}
                        </div>
                        {/* Navigation Buttons */}
                        {layouts.length > 3 && (
                            <>
                            <button 
                                onClick={() => handleScroll('left')}
                                className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                </svg>
                            </button>
                            <button 
                                onClick={() => handleScroll('right')}
                                className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                            </button>
                            </>
                        )}
                    </div>
                </div>
            
            </div>
        </div>
    </div>
  );
}

export default VirtualTourViewer;